<template>
  <div style="display:flex; justify-content: space-between;">
    <div style="display: flex; gap: 5px;">
      <h5 class="card-title mb-0">
        {{ title }}
        <slot></slot>
      </h5>
      <div v-if="chartType !== 'backlog'" style="padding-top: 2px;">
        <small style="font-weight: 600; font-size: 14px; color: #20a8d8;">
          {{ dateFrom }}
          <b v-if="dateFrom">|</b>
          {{ dateTo }}
        </small>
      </div>
    </div>
    <div v-if="productGroups || backProductGroups">
      <b-button
        v-if="productGroups"
        @click="emitFunction"
        class="btn-outline btn-sm ml-3"
        variant="outline-primary"
        right
      >
        Product Groups
      </b-button>
      <b-button
        v-if="backProductGroups"
        @click="emitFunction"
        class="btn-outline btn-sm ml-3"
        variant="outline-primary"
        right
      >
        Back
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderTitle",
  props: [
    "title",
    "dateFrom",
    "dateTo",
    "productGroups",
    "productGroupsEmit",
    "backProductGroups",
    "chartType"
  ],
  methods: {
    emitFunction() {
      this.$emit(this.productGroupsEmit);
    }
  }
};
</script>
